import { render, staticRenderFns } from "./ControleFontes.vue?vue&type=template&id=81c8dc60&scoped=true&"
import script from "./ControleFontes.vue?vue&type=script&lang=js&"
export * from "./ControleFontes.vue?vue&type=script&lang=js&"
import style0 from "./ControleFontes.vue?vue&type=style&index=0&id=81c8dc60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c8dc60",
  null
  
)

export default component.exports